/**
 * Centralized analytics event definitions.
 * Use these constants across all apps for consistent tracking.
 */
export const AnalyticsEvents = {
  // Authentication
  USER_SIGNED_UP: 'user_signed_up',
  USER_LOGGED_IN: 'user_logged_in',
  USER_LOGGED_OUT: 'user_logged_out',

  // Core Actions
  ITEM_ADDED: 'item_added',
  ITEM_CONSUMED: 'item_consumed',
  ITEM_WASTED: 'item_wasted',
  ITEM_DELETED: 'item_deleted',
  BARCODE_SCANNED: 'barcode_scanned',
  BARCODE_NOT_FOUND: 'barcode_not_found',
  PRODUCT_CREATED: 'product_created',

  // Households
  HOUSEHOLD_CREATED: 'household_created',
  HOUSEHOLD_JOINED: 'household_joined',
  HOUSEHOLD_LEFT: 'household_left',
  HOUSEHOLD_MEMBER_INVITED: 'household_member_invited',
  HOUSEHOLD_MEMBER_REMOVED: 'household_member_removed',

  // Storage
  STORAGE_LOCATION_CREATED: 'storage_location_created',
  STORAGE_LOCATION_DELETED: 'storage_location_deleted',

  // Subscription
  SUBSCRIPTION_VIEWED: 'subscription_viewed',
  UPGRADE_STARTED: 'upgrade_started',
  UPGRADE_COMPLETED: 'upgrade_completed',
  SUBSCRIPTION_CANCELLED: 'subscription_cancelled',

  // Features
  RECEIPT_SCAN_STARTED: 'receipt_scan_started',
  RECEIPT_SCAN_COMPLETED: 'receipt_scan_completed',
  RECEIPT_SCAN_FAILED: 'receipt_scan_failed',

  // Feature Engagement
  MEAL_PREP_STARTED: 'meal_prep_started',
  MEAL_PREP_COMPLETED: 'meal_prep_completed',
  BATCH_ENTRY_STARTED: 'batch_entry_started',
  BATCH_ENTRY_COMPLETED: 'batch_entry_completed',
  STATISTICS_VIEWED: 'statistics_viewed',
  PRODUCT_SEARCH_PERFORMED: 'product_search_performed',

  // Onboarding & Retention
  FIRST_ITEM_ADDED: 'first_item_added',
  NOTIFICATION_PERMISSION_REQUESTED: 'notification_permission_requested',
  NOTIFICATION_OPENED: 'notification_opened',

  // Errors
  BARCODE_SCAN_ERROR: 'barcode_scan_error',

  // Settings & Preferences
  THEME_CHANGED: 'theme_changed',
  BIOMETRIC_AUTH_TOGGLED: 'biometric_auth_toggled',
  ACCOUNT_LINKED: 'account_linked',
  ACCOUNT_UNLINKED: 'account_unlinked',

  // Sharing & Growth
  HOUSEHOLD_INVITE_LINK_COPIED: 'household_invite_link_copied',

  // OAuth Flow (prevents bounce tracking during OAuth redirects)
  AUTH_OAUTH_STARTED: 'auth_oauth_started',
  AUTH_OAUTH_COMPLETED: 'auth_oauth_completed',

  // Shopping Lists
  SHOPPING_LIST_CREATED: 'shopping_list_created',
  SHOPPING_LIST_ARCHIVED: 'shopping_list_archived',
  SHOPPING_LIST_DELETED: 'shopping_list_deleted',
  SHOPPING_LIST_PINNED: 'shopping_list_pinned',
  SHOPPING_LIST_ITEM_ADDED: 'shopping_list_item_added',
  SHOPPING_LIST_ITEM_CHECKED: 'shopping_list_item_checked',
  SHOPPING_LIST_ITEM_UNCHECKED: 'shopping_list_item_unchecked',
  SHOPPING_LIST_BATCH_ACTION: 'shopping_list_batch_action',
  SHOPPING_LIST_REORDERED: 'shopping_list_reordered',
  SHOPPING_LIST_UPGRADE_PROMPTED: 'shopping_list_upgrade_prompted',
} as const;

export type AnalyticsEvent = (typeof AnalyticsEvents)[keyof typeof AnalyticsEvents];
